import React from 'react';

import { Wrapper } from './styles';

export interface Props {
  width?: string;
}

const ModalContentWrapper: React.FunctionComponent<Props> = ({ width = '560px', children }) => {
  return <Wrapper width={width}>{children}</Wrapper>;
};

export default ModalContentWrapper;
